import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '../../../components/button'
import GstInvoiceItem from '../../../components/gstInvoiceItem'
import Input from '../../../components/input'
import Text from '../../../components/text'
import { useAxios } from '../../../core/AxiosContext'
import { useGlobal, useGlobalDispatch } from '../../../core/GlobalContext'
import { REQUEST_STATUS, ROUTES } from '../../../core/actions'
import {
  fetchEarningsReportUrlAction,
  fetchMisReportUrlAction,
  fetchOutstandingsReportUrlAction,
  searchGSTInvoicesAction,
} from '../FinancierDuck'
import * as styles from './Reports.css'

export const Reports = () => {
  const {
    financierState: { financier, gstInvoices, misReportStatus, earningsReportStatus, outstandingsReportStatus },
    documentsState: { docUrlMap },
  } = useGlobal()
  const { financierDispatch, documentsDispatch, toastDispatch } = useGlobalDispatch()
  const { authAxios } = useAxios()
  const [outstandingsDate, setOutstandingsDate] = useState()
  const [gstInvoicesSearch, setGstInvoicesSearch] = useState()

  const navigate = useNavigate()
  const handleBackIconPress = () => navigate(ROUTES.FINANCIER)

  const openInNewTab = link => {
    if (!link) return
    const a = document.createElement('a')
    a.href = link
    a.target = '_blank'
    a.rel = 'noopener noreferrer'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  const handleMISClick = () =>
    fetchMisReportUrlAction(financier?.financierPAN)(authAxios, financierDispatch, toastDispatch)(misUrl =>
      openInNewTab(misUrl)
    )

  const handleEarningsReport = () =>
    fetchEarningsReportUrlAction(financier?.financierPAN)(authAxios, financierDispatch)(earningsUrl =>
      openInNewTab(earningsUrl)
    )

  const handleOutstandingsReport = () =>
    fetchOutstandingsReportUrlAction(financier?.financierPAN, outstandingsDate)(authAxios, financierDispatch)(
      outstandingsUrl => openInNewTab(outstandingsUrl)
    )

  useEffect(() => {
    searchGSTInvoicesAction(financier?.financierPAN, gstInvoicesSearch)(authAxios, financierDispatch, documentsDispatch)
  }, [financier, gstInvoicesSearch])

  return (
    <div className={styles.reports}>
      <div className={styles.pagehead}>
        <Button handleClick={handleBackIconPress} type='icon' className={styles.backBtn}>
          <ion-icon name={'arrow-back'} />
        </Button>
        <Text size='1.3' className={styles.pageTitle}>
          Reports
        </Text>
      </div>
      <div className={styles.panel}>
        <div className={styles.tile}>
          <div className={styles.tileText}>
            <Text size='1.05' className={styles.tileTitle}>
              Latest MIS Report
            </Text>
            <Text size='0.85' color='var(--ib-muted)' className={styles.tileDesc}>
              consists of Wallet transaction ledger, collection details and GST Invoices
            </Text>
          </div>
          <div className={styles.tileAction}>
            <Button
              type='text'
              className={styles.downloadBtn}
              label={misReportStatus === REQUEST_STATUS.PENDING ? 'Generating' : 'Download'}
              handleClick={handleMISClick}
              disabled={misReportStatus === REQUEST_STATUS.PENDING}
            />
          </div>
        </div>
        <div className={styles.tile}>
          <div className={styles.tileText}>
            <Text size='1.05' className={styles.tileTitle}>
              Earnings Statement
            </Text>
            <Text size='0.85' color='var(--ib-muted)' className={styles.tileDesc}>
              consists of your earnings for every financial year
            </Text>
            <div className={styles.note}>
              <ion-icon name='information-circle-outline'></ion-icon>
              <Text size='0.8' color='var(--ib-faint)'>
                Earnings Statement will be updated on the 1st day of every financial quarter.
              </Text>
            </div>
          </div>
          <div className={styles.tileAction}>
            <Button
              type='text'
              className={styles.downloadBtn}
              label={earningsReportStatus === REQUEST_STATUS.PENDING ? 'Generating' : 'Download'}
              handleClick={handleEarningsReport}
              disabled={earningsReportStatus === REQUEST_STATUS.PENDING}
            />
          </div>
        </div>
        <div className={styles.tile}>
          <div className={styles.tileText}>
            <Text size='1.05' className={styles.tileTitle}>
              Outstandings Report
            </Text>
            <Text size='0.85' color='var(--ib-muted)' className={styles.tileDesc}>
              to view outstanding txns. until
            </Text>
          </div>
          <div className={styles.tileAction}>
            <Input
              className={styles.dateInput}
              value={outstandingsDate}
              type='date'
              name='outstandingsDate'
              onChange={val => setOutstandingsDate(val)}
            />
            <Button
              type='text'
              className={styles.downloadBtn}
              label={outstandingsReportStatus === REQUEST_STATUS.PENDING ? 'Generating' : 'Download'}
              handleClick={handleOutstandingsReport}
              disabled={outstandingsReportStatus === REQUEST_STATUS.PENDING}
            />
          </div>
        </div>
        <div className={styles.gstBlock}>
          <div className={styles.gstHead}>
            <div className={styles.tileText}>
              <Text size='1.05' className={styles.tileTitle}>
                GST Invoices
              </Text>
              <Text size='0.85' color='var(--ib-muted)' className={styles.tileDesc}>
                Click on the Invoice to download
              </Text>
            </div>
            <Input
              className={styles.searchInput}
              value={gstInvoicesSearch}
              name='gstInvoicesSearch'
              placeholder='Search Invoices'
              onChange={val => setGstInvoicesSearch(val)}
            />
          </div>
          <div className={styles.invoicesList}>
            {gstInvoices?.map(invoice => {
              return <GstInvoiceItem key={invoice?.invoiceNumber} invoice={invoice} />
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
